import { h } from 'preact';

export default function ViewMoreButton({
	getMoreNewsItemsHandler
}){
	function onClick(){
		getMoreNewsItemsHandler();
	}

	return (
		<div class="more-newsitems-button">
			<button class="button primary" onClick={onClick}>
				Toon meer berichten
			</button>
		</div>
	);
}
